"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConceptEditRequest = void 0;
const ConceptRequest_1 = require("./ConceptRequest");
class ConceptEditRequest extends ConceptRequest_1.ConceptRequest {
    constructor(requestType, createdDate, updatedDate, requesterId, subject, title, materialCategory, conceptMaterialId, feedback) {
        super(requestType, createdDate, updatedDate, requesterId, subject, title, materialCategory, feedback);
        this.conceptMaterialId = conceptMaterialId;
    }
    getConverter() {
        return ConceptEditRequest.converter;
    }
}
exports.ConceptEditRequest = ConceptEditRequest;
ConceptEditRequest.converter = {
    toFirestore(data) {
        const parent = ConceptRequest_1.ConceptRequest.converter.toFirestore(data);
        let child = {};
        if (data instanceof ConceptEditRequest) {
            child = {
                conceptMaterialId: data.conceptMaterialId
            };
        }
        return Object.assign(Object.assign({}, parent), child);
    },
    fromFirestore(snapshot) {
        const documentData = snapshot.data();
        const id = snapshot.id;
        const requestType = documentData.requestType;
        const createdDate = documentData.createdDate;
        const updatedDate = documentData.updatedDate;
        const requesterId = documentData.requesterId;
        const requestStatus = documentData.requestStatus;
        const subject = documentData.subject;
        const title = documentData.title;
        const materialCategory = documentData.materialCategory;
        const feedback = documentData.feedback;
        const conceptMaterialId = documentData.conceptMaterialId;
        const data = new ConceptEditRequest(requestType, createdDate, updatedDate, requesterId, subject, title, materialCategory, conceptMaterialId, feedback);
        data.requestStatus = requestStatus;
        data.id = id;
        return data;
    }
};
